(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["phalanx-card-colors"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('px-card-colors')) {
    customElements.define('px-card-colors', class extends HTMLElement {
      connectedCallback() {
        this.card = this.closest('.px-card, product-card');
        this.gallery = this.card?.querySelector('.px-draft-images') || this.card?.querySelector('.px-card-media, .card-gallery');
        if (!this.card || !this.gallery) return;
        if (!this.initialized) {
          this.initialized = true;
          this.originalTransition = this.card.getAttribute('data-featured-media-url');
          this.requestId = 0;
          this.addEventListener('click', event => this.selectColour(event));
          this.resizeObserver = new ResizeObserver(() => this.positionWithinMockup());
        }
        this.resizeObserver.observe(this.gallery);
        this.resizeObserver.observe(this.card);
        this.resizeObserver.observe(this);
        this.positionWithinMockup();
        const selected = this.querySelector('button[aria-pressed="true"]');
        if (selected) this.updateSelection(selected);
      }
      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        this.requestId++;
      }
      positionWithinMockup() {
        const parent = this.offsetParent;
        if (!parent || !this.gallery) return;
        const media = this.gallery.getBoundingClientRect();
        const origin = parent.getBoundingClientRect();
        if (!media.width || !media.height) return;
        const inset = parseFloat(getComputedStyle(this).getPropertyValue('--px-colour-inset')) || 0;
        this.style.maxWidth = Math.max(0, media.width - 54) + 'px';
        this.style.top = (media.bottom - origin.top - parent.clientTop + parent.scrollTop - this.offsetHeight - inset) + 'px';
        this.style.left = (media.left + media.width / 2 - origin.left - parent.clientLeft + parent.scrollLeft) + 'px';
        this.setAttribute('data-positioned', '');
      }
      updateSelection(button) {
        this.querySelectorAll('.px-colour-button').forEach(other => other.setAttribute('aria-pressed', String(other === button)));
        if (typeof this.card.applyVariantToLinks === 'function') {
          this.card.applyVariantToLinks(button.dataset.variant);
        } else {
          this.card.querySelectorAll('a[href]').forEach(link => {
            const url = new URL(link.href);
            url.searchParams.set('variant', button.dataset.variant);
            link.href = url.href;
          });
        }
      }
      loadPreviewImage(src, srcset, className = '') {
        return new Promise((resolve, reject) => {
          const img = new Image(700, 700);
          img.alt = '';
          img.className = className;
          img.sizes = '(min-width: 750px) 25vw, 50vw';
          img.onload = () => resolve(img);
          img.onerror = reject;
          img.srcset = srcset || '';
          img.src = src;
        });
      }
      async selectColour(event) {
        const button = event.target.closest('.px-colour-button');
        if (!button || !this.card) return;
        event.preventDefault();
        event.stopPropagation();
        const requestId = ++this.requestId;
        if (button.dataset.original === 'true' || !button.dataset.image) {
          this.updateSelection(button);
          if (this.preview) this.preview.hidden = true;
          if (this.originalTransition) this.card.setAttribute('data-featured-media-url', this.originalTransition);
          this.removeAttribute('aria-busy');
          return;
        }
        this.setAttribute('aria-busy', 'true');
        try {
          // Keep the previous mockup visible until the replacement has loaded.
          const front = await this.loadPreviewImage(button.dataset.image, button.dataset.srcset);
          if (requestId !== this.requestId || !this.isConnected) return;
          if (!this.preview) {
            this.preview = document.createElement('div');
            this.preview.className = 'px-colour-preview';
            this.preview.setAttribute('aria-hidden', 'true');
            this.gallery.append(this.preview);
          }
          this.preview.replaceChildren(front);
          this.preview.hidden = false;
          this.updateSelection(button);
          this.card.setAttribute('data-featured-media-url', button.dataset.image);
          if (button.dataset.hover) {
            this.loadPreviewImage(button.dataset.hover, button.dataset.hoverSrcset, 'px-colour-back')
              .then(back => {
                if (requestId === this.requestId && this.isConnected) this.preview.append(back);
              }).catch(() => {});
          }
        } catch {
          // Keep the previous image, selection and links together on a network error.
        } finally {
          if (requestId === this.requestId) this.removeAttribute('aria-busy');
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["phalanx-draft-gallery"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('phalanx-draft-gallery'))customElements.define('phalanx-draft-gallery',class extends HTMLElement{
 async connectedCallback(){
  const { StandardEvents: PxDraftEvents } = await import('@shopify/events');
  if (!this.isConnected) return;
  this.controller = new AbortController();
  this.closest('.shopify-section, dialog')?.addEventListener(PxDraftEvents.productSelect,event=>{
    if(event.target.closest('product-card'))return;
    const request = this.request = (this.request || 0) + 1;
    event.promise?.then(({detail})=>{
      if(request!==this.request || !this.isConnected)return;
      const replacement=detail?.html?.querySelector('phalanx-draft-gallery[data-mockup-product="'+this.dataset.mockupProduct+'"]');
      if(replacement)this.replaceWith(replacement);
    }).catch(()=>{});
  },{signal:this.controller.signal});
  const track=this.querySelector('.px-draft-track');const buttons=[...this.querySelectorAll('[data-slide]')];
  buttons.forEach(button=>button.addEventListener('click',()=>track.scrollTo({left:Number(button.dataset.slide)*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})));
  track.addEventListener('scroll',()=>{const index=Math.round(track.scrollLeft/track.clientWidth);buttons.forEach((button,i)=>button.setAttribute('aria-pressed',String(i===index)))});
 }
 disconnectedCallback(){this.controller?.abort();}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["phalanx-draft-images"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('phalanx-card-swipe')) {
  customElements.define('phalanx-card-swipe', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const card = this.closest('.px-card, product-card');
      const hasBack = () => {
        const preview = this.querySelector('.px-colour-preview:not([hidden])');
        return !!(preview ? preview.querySelector('.px-colour-back') : this.querySelector('.px-draft-back'));
      };
      this.addEventListener('pointerdown', event => {
        if (!event.isPrimary || event.button !== 0 || !matchMedia('(hover:none),(max-width:749px)').matches || !hasBack()) return;
        this.gesture = { id: event.pointerId, x: event.clientX, y: event.clientY };
      }, options);
      this.addEventListener('pointermove', event => {
        const gesture = this.gesture;
        if (!gesture || gesture.id !== event.pointerId) return;
        const dx = event.clientX - gesture.x;
        const dy = event.clientY - gesture.y;
        if (!gesture.horizontal && Math.abs(dy) > 12 && Math.abs(dy) > Math.abs(dx)) {
          this.gesture = null;
          return;
        }
        if (Math.abs(dx) > 12 && Math.abs(dx) > Math.abs(dy) * 1.25) {
          gesture.horizontal = true;
          this.setPointerCapture(event.pointerId);
          event.preventDefault();
          event.stopPropagation();
        }
      }, options);
      this.addEventListener('pointerup', event => {
        const gesture = this.gesture;
        this.gesture = null;
        if (!gesture || gesture.id !== event.pointerId || !gesture.horizontal) return;
        this.suppressClickUntil = Date.now() + 500;
        const dx = event.clientX - gesture.x;
        if (Math.abs(dx) >= 30 && hasBack()) this.classList.toggle('px-show-back', dx < 0);
        event.stopPropagation();
      }, options);
      this.addEventListener('pointercancel', () => { this.gesture = null; }, options);
      this.addEventListener('dragstart', event => event.preventDefault(), options);
      card?.addEventListener('click', event => {
        if (event.target.closest('px-card-colors')) {
          this.classList.remove('px-show-back');
          return;
        }
        if (Date.now() < (this.suppressClickUntil || 0)) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, { ...options, capture: true });
      this.addEventListener('keydown', event => {
        if (event.target !== this || !hasBack() || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        this.classList.toggle('px-show-back', event.key === 'ArrowRight');
      }, options);
    }
    disconnectedCallback() { this.controller?.abort(); this.gesture = null; }
  });
}
  } catch(e) { console.error(e); }
})();

})();
